/**
 * The check-in's last answer, kept in this browser only (2026-10-27 jam): coming back to `/friends/checkin/:roomId`
 * shows the face picked before. The server keeps no answer to read back; a new device or cleared storage asks again,
 * which is fine. Only love it / it's okay are kept — a stop closes the chat, and the page then says so on its own.
 */
export type KeptCheckinAnswer = 'keep' | 'okay';

const KEY_PREFIX = 'ember.friend_checkin.';
const local = (): Storage => window.localStorage;

export function keptCheckinAnswer(roomId: string, storage: () => Storage = local): KeptCheckinAnswer | null {
  try {
    const v = storage().getItem(KEY_PREFIX + roomId);
    return v === 'keep' || v === 'okay' ? v : null;
  } catch { return null; }
}

export function keepCheckinAnswer(roomId: string, answer: 'keep' | 'okay' | 'stop', storage: () => Storage = local): void {
  try {
    if (answer === 'stop') storage().removeItem(KEY_PREFIX + roomId);
    else storage().setItem(KEY_PREFIX + roomId, answer);
  } catch { /* this visit only */ }
}
